<template src="./login.html"></template>

<script>
  import auth from '../../helpers/auth'

  export default {
    data () {
      return {
        email: null,
        password: null
      }
    },
    methods: {
      login () {
        const form = this.$el && this.$el.querySelector ? this.$el.querySelector('form.login') : null
        const emailInput = form ? form.querySelector('input[type="text"], input[type="email"]') : null
        const passwordInput = form ? form.querySelector('input[type="password"]') : null
        const email = String((this.email != null ? this.email : (emailInput && emailInput.value)) || '').trim()
        const password = String((this.password != null ? this.password : (passwordInput && passwordInput.value)) || '')
        auth.login(this, email, password)
      }
    },
    mounted: function () {
      if (this.$store.getters['user/isAuthenticated']) {
        this.$router.push('/')
      }
    }
  }
</script>

<style>

</style>
